// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { createElement } from "react";
// import { message } from "antd";

import * as antd from "antd"; // Will Export All antd-components to User-script

import dict from "../../../../dict/app";

import type Ifnc from "../types/Ifnc.d.ts";
import type {Tpermissions} from "../types/easyTypes.ts";
import type {Tapp} from "../types/uiapp.d.ts";
// import type {TelementJSON, TuniversalElementProps} from "./Iuigen.d.ts";

import SpanE from "../components/react/SpanE.tsx";

const {rz, $} = window;

const fnc:Ifnc = {
  config: {result: false, cfgtime: 0, lng: "en", theme: "dark", compact: false},
  stopActions: {changeLanguage: false, changeTheme: false, changeCompact: false, changeShowDesktopIconsTitle: false, userExit: false, userLogin: false, ssoLogin: false, loadApps: false, loadPage: false},
  memorizedValues: {app: undefined, mainmenu: [], apps: [], desktopApps: []},

  getSettings: async () => {
    let jsn:any = {result: false};
    const resp = await fetch("/api/usersettings", {method: "GET", credentials: "include", mode: "same-origin", headers: {"Content-Type": "application/json;charset=utf-8", Accept: "application/json"}});
    if (!resp.ok) {
      console.log({caller: "fnc.getSettings -> fetch(GET) -> error", error: resp.status});
      return {result: false, err: "Error response status: " + resp.status};
    }

    const ssnsHeader = resp.headers.get("X-Session-Info") || "";
    try { jsn = {result: true, ssns: rz.objFromJSON(rz.Base64decode(ssnsHeader || ""))} }
    catch (err2) {
      console.log({caller: "fnc.getSettings -> parse session header -> error", error: err2});
      return {result: false, err: "Invalid session metadata"};
    }

    const cfg = fnc.config, dct = window["dict-app"][(cfg && cfg.lng) || "en"];
    // @ts-ignore
    if (!jsn || !jsn.ssns) { return {result: false, err: (jsn && jsn.err) || dct.e.cryptoError1} }
    // @ts-ignore
    const key = await rz.getCryptoKey({session: jsn.ssns});
    if (!key) { return {result: false, err: "Invalid Crypto Key"} }

    const encryptedBuffer = await resp.arrayBuffer();
    // @ts-ignore
    const ans2 = await rz.decryptData(encryptedBuffer, key);
    if (ans2.err === "Crypto Error: OperationError") { ans2.err = dct.e.cryptoError1 }
    if (ans2.err || !ans2.data) { return ans2 }

    fnc.config = {...ans2.data, cfgtime: (new Date()).getTime()};
    return {...ans2.data};
  },

  changeLanguage: async (curlng) => {
    // Block fast double action
    if (fnc.stopActions.changeLanguage) { return curlng }
    fnc.stopActions.changeLanguage = true; setTimeout(() => { fnc.stopActions.changeLanguage = false }, 300);

    const data = { curlng };
    if (fnc.config?.isDev) rz.log({message: "Change LNG -> " + curlng, caller: "fnc.changeLanguage()"});
    const res = await fetch("/api/changelng", {method: "POST", credentials: "include", mode: "same-origin", body: JSON.stringify(data), headers: {"Content-Type": "application/json;charset=utf-8", Accept: "application/json"}});
    let ans = await res.json();

    if (!ans || !ans.result || !ans.curlng) {
      if (rz.isString(ans) || !ans) ans = {ans};
      if (fnc.config?.isDev) rz.log({message: "Cant change LNG on Server! Response:\n" + JSON.stringify(ans), caller: "fnc.changeLanguage()"});
      return "";
    }
    fnc.config.lng = ans.curlng;
    dict.set(ans.curlng);
    // Change head and meta tags
    $("meta[name='description']").attr("content", dict[ans.curlng].p.prgtitle);
    $("html").attr("lang", ans.curlng);
    document.title = dict[ans.curlng].p.prgtitle;
    return ans.curlng;
  },

  changeTheme: async (theme) => {
    // Block fast double action
    if (fnc.stopActions.changeTheme) { return theme }
    fnc.stopActions.changeTheme = true; setTimeout(() => { fnc.stopActions.changeTheme = false }, 300);
    // if (e && rz.isObject(e) && e.preventDefault) e.preventDefault();
    const data = { theme };
    if (fnc.config?.isDev) rz.log({message: "Change Theme -> " + theme, caller: "fnc.changeTheme()"});
    const res = await fetch("/api/changetheme", {method: "POST", credentials: "include", mode: "same-origin", body: JSON.stringify(data), headers: {"Content-Type": "application/json;charset=utf-8", Accept: "application/json"}});
    let ans = await res.json();
    if (!ans || !ans.result || !ans.theme) {
      if (rz.isString(ans) || !ans) ans = {ans};
      if (fnc.config?.isDev) rz.log({message: "Cant change Theme on Server! Response:\n" + JSON.stringify(ans), caller: "fnc.changeTheme()"});
      return "";
    }
    fnc.config.theme = ans.theme;
    $("html").attr("data-theme", ans.theme);
    return ans.theme;
  },

  changeCompact: async (compact) => {
    // Block fast double action
    if (fnc.stopActions.changeCompact) { return compact }
    fnc.stopActions.changeCompact = true; setTimeout(() => { fnc.stopActions.changeCompact = false }, 300);
    const data = { compact, dummy: "dummy" };
    if (fnc.config?.isDev) rz.log({message: "Change Compact-Intarface -> " + compact, caller: "fnc.changeCompact()"});
    const res = await fetch("/api/changecompact", {method: "POST", credentials: "include", mode: "same-origin", body: JSON.stringify(data), headers: {"Content-Type": "application/json;charset=utf-8", Accept: "application/json"}});
    let ans = await res.json();
    if (!ans || !ans.result) {
      if (rz.isString(ans) || !ans) ans = {ans};
      if (fnc.config?.isDev) rz.log({message: "Cant change Compact-Intarface on Server! Response:\n" + JSON.stringify(ans), caller: "fnc.changeCompact()"});
      return false;
    }
    fnc.config.compact = ans.compact;
    $("html").attr("data-compact", String(ans.compact));
    return ans.compact;
  },

  changeShowDesktopIconsTitle: async (showDesktopIconsTitle) => {
    // Block fast double action
    if (fnc.stopActions.changeShowDesktopIconsTitle) { return showDesktopIconsTitle }
    fnc.stopActions.changeShowDesktopIconsTitle = true; setTimeout(() => { fnc.stopActions.changeShowDesktopIconsTitle = false }, 300);
    const data = { showDesktopIconsTitle, dummy: "dummy" };
    if (fnc.config?.isDev) rz.log({message: "Change Show Desktop Icons Title -> " + showDesktopIconsTitle, caller: "fnc.changeShowDesktopIconsTitle()"});
    const res = await fetch("/api/changeiconstitle", {method: "POST", credentials: "include", mode: "same-origin", body: JSON.stringify(data), headers: {"Content-Type": "application/json;charset=utf-8", Accept: "application/json"}});
    let ans = await res.json();
    if (!ans || !ans.result) {
      if (rz.isString(ans) || !ans) ans = {ans};
      if (fnc.config?.isDev) rz.log({message: "Cant change the 'Show Desktop Icons Title' param on Server! Response:\n" + JSON.stringify(ans), caller: "fnc.changeShowDesktopIconsTitle()"});
      return false;
    }
    fnc.config.showDesktopIconsTitle = ans.showDesktopIconsTitle;
    $("html").attr("data-icons-title", String(ans.showDesktopIconsTitle));
    return ans.showDesktopIconsTitle;
  },

  userExit: async () => {
    // Block fast double action
    if (fnc.stopActions.userExit) { return }
    fnc.stopActions.userExit = true; setTimeout(() => { fnc.stopActions.userExit = false }, 300);

    if (fnc.config?.isDev) rz.log({message: "fnc.userExit()", caller: "fnc.userExit()", module: "fnc.ts"});
    const res = await fetch("/api/userexit", {method: "POST", credentials: "include", mode: "same-origin", headers: {"Content-Type": "application/json;charset=utf-8"}});
    const ans = await res.json();
    window.location.replace("/app/login"); //  window.location.href = "/app/login?url=" + window.location.pathname;
    return ans;
  },

  userLogin: async (e) => {
    // Block fast double action
    if (fnc.stopActions.userLogin) { return {result: false, err: "Prevent double action: userLogin()"} }
    fnc.stopActions.userLogin = true; setTimeout(() => { fnc.stopActions.userLogin = false }, 300);

    if (!e || !e.user || !e.pass || !e.user.length || !e.pass.length) {
      if (fnc.config?.isDev) rz.log({message: "fnc.userLogin(user, pass) -> Error: Arguments 'user' or 'pass' are null or empty", caller: "fnc.userLogin()", module: "fnc.ts"});
      return {result: false, err: "Arguments 'user' or 'pass' are null or empty"};
    }

    if (!crypto || !crypto.subtle || !crypto.subtle.digest) { return {result: false, err: "Invalid Crypto Key"} }

    if (fnc.config?.isDev) rz.log({message: "fnc.userLogin(" + e.user + ", ***)", caller: "fnc.userLogin()", module: "fnc.ts"});
    const data = {login: e.user, pass: rz.strReverse(rz.Base64encode(e.pass)), authId: fnc.config.authId, codeAccepted: e.codeAccepted};
    const res = await fetch("/api/stdlogin", {method: "POST", credentials: "include", mode: "same-origin", body: JSON.stringify(data), headers: {"Content-Type": "application/json;charset=utf-8"}});
    if (res.status !== 200) {
      const e1 = "Error response status: " + res.status;
      antd.message.error(createElement(SpanE, {className: "txt-black"}, e1), 5);
      if (fnc.config?.isDev) rz.log({message: e1, caller: "fnc.userLogin()", module: "fnc.ts"});
      return {result: false, err: e1, user: {name: null, login: null, groups: null}};
    }
    const ans = await res.json();
    // Debug:
    if (fnc.config?.isDev) console.log(ans);
    fnc.config.authId = "";

    if (!ans || !ans.result || !ans.user || !ans.user.login) {
      // Ban
      if (ans.banned) { antd.message.error(createElement(SpanE, {className: "txt-black"}, (rz.errToString(ans.err) || "You are banned!")), 5); window.location.href = "/ban" }
      // Error login
      let e1 = rz.errToString(ans.err) || "Invalid Credentials! You may be blocked!";
      if (e1 && ~e1.indexOf("</BODY></HTML>")) { e1 = rz.strSubString(e1, "<BODY>", "</BODY>") }
      else if (e1 && ~e1.indexOf("</body></html>")) { e1 = rz.strSubString(e1, "<body>", "</body>") }

      antd.message.error(createElement(SpanE, {className: "txt-black"}, e1), 5);
      if (fnc.config?.isDev) rz.log({message: "fnc.userLogin(user, pass) Fail -> " + e1, caller: "fnc.userLogin()", module: "fnc.ts"});
      return {result: false, err: e1, user: {name: null, login: null, groups: null}};
    }
    // Success login
    if (fnc.config?.isDev) rz.log({message: "fnc.userLogin(user, pass) -> " + dict[fnc.config.lng || "en"].i.userLoggedSuccess, caller: "fnc.userLogin()", module: "fnc.ts"});
    antd.message.success(createElement(SpanE, {className: "txt-black"}, (dict[fnc.config.lng || "en"].i.userLoggedSuccess || "You have successfully authorized")), 3);
    // setTimeout(() => { if (~window.location.href.indexOf("/app/login")) { window.location.href = "/app" } }, 3000);
    return ans;
  },

  ssoLogin: async () => {
    // Block fast double ssoLogin
    if (fnc.stopActions.ssoLogin) { return {result: false, err: "Prevent double action: ssoLogin()"} }
    fnc.stopActions.ssoLogin = true; setTimeout(() => { fnc.stopActions.ssoLogin = false }, 300);
    fnc.config.authId = "";

    if (!crypto || !crypto.subtle || !crypto.subtle.digest) { return {result: false, err: "Invalid Crypto Key"} }

    if (fnc.config?.isDev) rz.log({message: "fnc.ssoLogin() Sending request...", caller: "fnc.ssoLogin()", module: "fnc.ts"});

    const res = await fetch("/api/ssologin", {method: "POST", credentials: "include", mode: "same-origin", body: JSON.stringify({comand: "ssoLogin"}), headers: {"Content-Type": "application/json;charset=utf-8", Accept: "application/json"}});
    const ans = await res.json();
    if (ans && ans.result && ans.user && ans.user.login) {
      if (fnc.config.isDev) rz.log({message: "fnc.ssoLogin() -> " + dict[fnc.config.lng || "en"].i.userLoggedSuccess, caller: "fnc.ssoLogin()", module: "fnc.js"});
      antd.message.success(createElement(SpanE, {className: "txt-black"}, (dict[fnc.config.lng || "en"].i.userLoggedSuccess || "You have successfully authorized")), 3);
      // setTimeout(() => { if (~window.location.href.indexOf("/app/login")) { window.location.href = "/app" } }, 3000);
      return ans;
    }
    // eslint-disable-next-line no-else-return
    else {
      if (fnc.config.isDev) rz.log({message: "fnc.ssoLogin() Error -> " + ans.err || "", caller: "fnc.ssoLogin()", module: "fnc.js"});
      return {result: false, err: ans.err, user: {name: null, login: null, email: null, groups: null}};
    }
  },

  sendAuthCode: async (userlogin) => {
    // Block fast double action
    if (fnc.stopActions.sendAuthCode) { return {result: false, err: "Prevent double action: sendAuthCode()"} }
    fnc.stopActions.sendAuthCode = true; setTimeout(() => { fnc.stopActions.sendAuthCode = false }, 1000);
    const dct = dict[fnc.config.lng || "en"];
    fnc.config.authId = "";
    const res = await fetch("/api/sendauthcode", {method: "POST", credentials: "include", mode: "same-origin", body: JSON.stringify({login: userlogin}), headers: {"Content-Type": "application/json;charset=utf-8"}});
    if (res.status !== 200) {
      const e1 = "Error response status: " + res.status;
      antd.message.error(createElement(SpanE, {className: "txt-black"}, e1), 5);
      if (fnc.config?.isDev) rz.log({message: e1, caller: "fnc.sendAuthCode()", module: "fnc.ts"});
      return {result: false, err: e1};
    }
    const ans = await res.json();

    if (!ans || !ans.result) {
      if (fnc.config.isDev) console.log(ans);
      // Ban
      if (ans.banned) { antd.message.error(createElement(SpanE, {className: "txt-black"}, (rz.errToString(ans.err) || "You are banned!")), 5); window.location.href = "/ban" }
      // Error login
      let e1 = ans.err || ans.msg || "Invalid Credentials! You may be blocked!";
      if (e1 && ~e1.indexOf("</BODY></HTML>")) { e1 = rz.strSubString(e1, "<BODY>", "</BODY>") }
      else if (e1 && ~e1.indexOf("</body></html>")) { e1 = rz.strSubString(e1, "<body>", "</body>") }

      antd.message.error(createElement(SpanE, {className: "txt-black"}, e1), 5);
      if (fnc.config?.isDev) rz.log({message: "fnc.sendAuthCode(userlogin) Fail -> " + e1, caller: "fnc.sendAuthCode()", module: "fnc.ts"});
      return {result: false, err: e1};
    }
    // Sent success
    if (fnc.config?.isDev) rz.log({message: "fnc.sendAuthCode(userlogin) -> " + dct.i.codeHasBeenSent + "; authId=" + ans.authId, caller: "fnc.sendAuthCode()", module: "fnc.ts"});
    fnc.config.authId = ans.authId;
    antd.message.success(createElement(SpanE, {className: "txt-black"}, dct.i.codeHasBeenSent), 3); return ans;
  },

  loadAllApps: async () => {
    // if (fnc.config?.isDev) rz.log({message: "fnc.loadAllApps()", caller: "fnc.loadAllApps()", module: "fnc.ts"});
    const res = await fetch("/ui/apps", {method: "GET", credentials: "include", mode: "same-origin", headers: {"Content-Type": "application/json;charset=utf-8", Accept: "application/json"}});
    const ssnsHeader = res.headers.get("X-Session-Info") || "";
    let ssns;
    try { ssns = rz.objFromJSON(rz.Base64decode(ssnsHeader || "")) }
    catch (err) { console.log(err); return {result: false, err: "Invalid session metadata"} }
    if (!ssns || !ssns.userip || !ssns.lng || !ssns.theme) { return {result: false, err: "Invalid session metadata"} }

    const key = await rz.getCryptoKey({session: ssns});
    if (!key) { return {result: false, err: "Invalid Crypto Key"} }

    const encryptedBuffer = await res.arrayBuffer();
    const ans2 = await rz.decryptData(encryptedBuffer, key);
    if (ans2.err === "Crypto Error: OperationError") { const cfg = fnc.config, dct = window["dict-app"][(cfg && cfg.lng) || "en"]; ans2.err = dct.e.cryptoError1 }
    if (ans2.err || !ans2.data) { return ans2 }

    fnc.memorizedValues.mainmenu = ans2.data.mainmenu || [];
    fnc.memorizedValues.usermenu = ans2.data.usermenu || [];
    fnc.memorizedValues.apps = ans2.data.apps || [];
    fnc.memorizedValues.desktopApps = ans2.data.desktopApps || [];
    return ans2.data;
  },

  loadPage: async (app:Tapp) => {
    if (!app || !app.key) { return {result: false, err: "loadPage(app) Error: Arg app.key is null or empty!"} }
    // Block fast double action
    if (fnc.stopActions.loadPage) {
      await rz.delay(500);
      if (fnc.memorizedValues.app && app.key === fnc.memorizedValues.app.key) { return {result: true, app: rz.objClone(fnc.memorizedValues.app)} }
      // return {result: false, err: "Prevent double action: loadPage(" + app.key + ")"}
    }
    fnc.stopActions.loadPage = true; setTimeout(() => { fnc.stopActions.loadPage = false; fnc.memorizedValues.app = undefined; }, 1000);

    // if (fnc.config?.isDev) rz.log({message: "fnc.loadPage('" + app.key + "')", caller: "fnc.loadPage()", module: "fnc.ts"});
    const res = await fetch("/ui/page", {method: "POST", credentials: "include", mode: "same-origin", body: JSON.stringify({key: app.key, link: app.link}), headers: {"Content-Type": "application/json;charset=utf-8"}});
    const ssnsHeader = res.headers.get("X-Session-Info") || "";
    let ssns;
    try { ssns = rz.objFromJSON(rz.Base64decode(ssnsHeader || "")) }
    catch (err) { console.log(err); return {result: false, err: "Invalid session metadata"} }

    const key = await rz.getCryptoKey({session: (ssns || undefined)});
    if (!key) { return {result: false, err: "Invalid Crypto Key"} }
    const encryptedBuffer = await res.arrayBuffer();
    const ans2 = await rz.decryptData(encryptedBuffer, key);
    if (ans2.err === "Crypto Error: OperationError") { const cfg = fnc.config, dct = window["dict-app"][(cfg && cfg.lng) || "en"]; ans2.err = dct.e.cryptoError1 }
    if (ans2.err || !ans2.data) { return ans2 }

    fnc.memorizedValues.app = ans2.data.app;
    return ans2.data;
  },

  dynamicallyLoadScripts: (app:Tapp) => new Promise((resolve) => {
    if (!app || !app.key) { return {result: false, err: "dynamicallyLoadScripts(app) Error: Arg app.key is null or empty!"} }
    if (!app.templateXML) { return {result: false, err: "dynamicallyLoadScripts(app) Error: Arg app.templateXML is null or empty!"} }
    if (!app.scripts || !app.scripts.length) { return {result: true, scripts: []} }

    const ans:{scripts:Array<string>, result:boolean, err?:string} = {scripts: [], result: true, err: ""};

    const loadedScripts:string[] = [], errs:Array<string> = [];

    $("script").each((s, ss) => {
      const fname2:string = (rz.strFileName($(ss).attr("src"))).toLowerCase().trim();
      loadedScripts.push(fname2);
    });

    // Middle function
    const loadNextScript = (ph:string) => new Promise((res1) => {
      if (rz.arrContains(loadedScripts, ph, true, true)) { return res1(ph) }
      const script = document.createElement("script");
      script.src = "/ui/js/" + ph;
      script.onload = () => { loadedScripts.push(ph); res1(ph) };
      script.onerror = (err1) => {
        errs.push("Failed to load script '" + script.src + "'. " + rz.errToString(err1));
        if (fnc.config?.isDev) console.log(err1);
        res1("");
      };
      document.body.appendChild(script);
    });

    // Main function
    let alreadyResolve = false;
    const doItAgain = (page) => {
      if (page > 100 || page >= (app.scripts || []).length) { // Infinite loop guard
        if (!alreadyResolve) {
          alreadyResolve = true; ans.result = Boolean(ans.scripts.length); ans.err = errs.join("\n");
          resolve(ans);
        }
        return;
      }
      loadNextScript((app.scripts || [])[page]).then((ph) => {
        if (ph) { ans.scripts.push(ph as string) }
        setTimeout((cnt) => { doItAgain(cnt) }, 200, (page + 1));
      });
    };
    // Do it
    doItAgain(0);
  }),

  dynamicallyRemoveScripts: async (app:Tapp) => {
    if (!app || !app.key) { return {result: false, err: "dynamicallyLoadScripts(app) Error: Arg app.key is null or empty!"} }
    if (!app.scripts || !app.scripts.length) { return {result: true, scripts: []} }
    const scripts:string[] = [];
    app.scripts.forEach((ph) => {
      const scr = $("script[scr$='/" + ph + "']");
      if (scr[0]) { $(scr[0]).remove(); scripts.push(ph) }
    });
    return {result: true, scripts}
  },

  getUserRolesForApp: (userObject, app) => {
    if (!userObject || !userObject.login || !userObject.groups || !userObject.groups.length || !app.roles || !app.roles.length) return [];
    const curDate = rz.dateToString(new Date(), "YYYY-MM-DD");
    const userRoles:Array<string> = [];
    app.roles.forEach((cr) => {
      (cr?.groups || []).forEach((dbg) => {
        if (~(userObject.groups as Array<string>).indexOf(dbg.group) && (!dbg.expired || dbg.expired > curDate) && !~userRoles.indexOf(cr.role)) { userRoles.push(cr.role) }
      });
      (cr?.users || []).forEach((dbg) => {
        if (dbg.user.toLowerCase() === userObject.login?.toLowerCase() && (!dbg.expired || dbg.expired > curDate) && !~userRoles.indexOf(cr.role)) { userRoles.push(cr.role) }
      });
    });
    return userRoles;
  },

  checkPermissions: (userObject, attrs, allApps) => {
    const ans:Tpermissions = {visible: undefined, disabled: undefined, editable: undefined, delete: undefined, created: undefined};
    const curApp = (allApps || fnc.memorizedValues.apps).find((aa) => (aa.key === attrs?.rootAttributes?.key));
    if (!curApp) return ans;
    const userRoles:Array<string> = fnc.getUserRolesForApp(userObject, curApp);
    if (!userRoles || !userRoles.length) { return ans }
    /* eslint-disable max-len */
    if ((attrs.hiddenRoles || attrs.hiddenForRoles || attrs.disallowedForRoles)) {
      if (rz.arrCompare((attrs.hiddenRoles || attrs.hiddenForRoles || attrs.disallowedForRoles || "").replace((/(\s+|\||,|;)/igm), ";").split(";"), userRoles, "includesAny")) { ans.visible = false } else { ans.visible = true }
    }
    if ((attrs.visibleRoles || attrs.visibleForRoles || attrs.allowedForRoles)) {
      if (rz.arrCompare((attrs.visibleRoles || attrs.visibleForRoles || attrs.allowedForRoles || "").replace((/(\s+|\||,|;)/igm), ";").split(";"), userRoles, "includesAny")) { ans.visible = true } else { ans.visible = false }
    }

    if ((attrs.disableRoles || attrs.disabledRoles || attrs.disableForRoles || attrs.disabledForRoles)) {
      if (rz.arrCompare((attrs.disableRoles || attrs.disabledRoles || attrs.disableForRoles || attrs.disabledForRoles || "").replace((/(\s+|\||,|;)/igm), ";").split(";"), userRoles, "includesAny")) { ans.disabled = true } else { ans.disabled = false }
    }
    if ((attrs.enableRoles || attrs.enabledRoles || attrs.enableForRoles || attrs.enabledForRoles)) {
      if (rz.arrCompare((attrs.enableRoles || attrs.enabledRoles || attrs.enableForRoles || attrs.enabledForRoles || "").replace((/(\s+|\||,|;)/igm), ";").split(";"), userRoles, "includesAny")) { ans.disabled = false } else { ans.disabled = true }
    }

    if (attrs.safe === "hidden" && fnc.config.safe) { ans.visible = false }
    if (attrs.safe === "disabled" && fnc.config.safe) { ans.disabled = true }

    // if ((attrs.viewRoles || attrs.viewForRoles || attrs.viewonlyRoles || attrs.viewonlyForRoles) && rz.arrCompare((attrs.viewRoles || attrs.viewForRoles || attrs.viewonlyRoles || attrs.viewonlyForRoles || "").replace((/(\s+|\||,|;)/igm), ";").split(";"), userRoles, "includesAny")) { ans.created = false; ans.editable = false; ans.delete = false }
    // if ((attrs.allowAllRoles || attrs.allowedAllRoles || attrs.allowAllForRoles || attrs.allowedAllForRoles) && rz.arrCompare((attrs.allowAllRoles || attrs.allowedAllRoles || attrs.allowAllForRoles || attrs.allowedAllForRoles || "").replace((/(\s+|\||,|;)/igm), ";").split(";"), userRoles, "includesAny")) { ans.created = true; ans.editable = true; ans.delete = true }

    // if ((attrs.notEditRoles || attrs.notEditableRoles || attrs.notEditForRoles || attrs.notEaditableForRoles) && rz.arrCompare((attrs.notEditRoles || attrs.notEditableRoles || attrs.notEditForRoles || attrs.notEaditableForRoles || "").replace((/(\s+|\||,|;)/igm), ";").split(";"), userRoles, "includesAny")) { ans.editable = false }
    // if ((attrs.editRoles || attrs.editableRoles || attrs.editForRoles || attrs.editableForRoles) && rz.arrCompare((attrs.editRoles || attrs.editableRoles || attrs.editForRoles || attrs.editableForRoles || "").replace((/(\s+|\||,|;)/igm), ";").split(";"), userRoles, "includesAny")) { ans.editable = true }

    // if ((attrs.notCreateRoles || attrs.notCreatedRoles || attrs.notCreateForRoles || attrs.notCreatedForRoles) && rz.arrCompare((attrs.notCreateRoles || attrs.notCreatedRoles || attrs.notCreateForRoles || attrs.notCreatedForRoles || "").replace((/(\s+|\||,|;)/igm), ";").split(";"), userRoles, "includesAny")) { ans.created = false }
    // if ((attrs.createRoles || attrs.createdRoles || attrs.createForRoles || attrs.createdForRoles) && rz.arrCompare((attrs.createRoles || attrs.createdRoles || attrs.createForRoles || attrs.createdForRoles || "").replace((/(\s+|\||,|;)/igm), ";").split(";"), userRoles, "includesAny")) { ans.created = true }

    // if ((attrs.notDeleteRoles || attrs.notDeletedRoles || attrs.notDeleteForRoles || attrs.notDeletedForRoles || attrs.notRemoveRoles || attrs.notRemoveForRoles) && rz.arrCompare((attrs.notDeleteRoles || attrs.notDeletedRoles || attrs.notDeleteForRoles || attrs.notDeletedForRoles || attrs.notRemoveRoles || attrs.notRemoveForRoles || "").replace((/(\s+|\||,|;)/igm), ";").split(";"), userRoles, "includesAny")) { ans.delete = false }
    // if ((attrs.deleteRoles || attrs.deletedRoles || attrs.deleteForRoles || attrs.deletedForRoles || attrs.removeRoles || attrs.removeForRoles) && rz.arrCompare((attrs.deleteRoles || attrs.deletedRoles || attrs.deleteForRoles || attrs.deletedForRoles || attrs.removeRoles || attrs.removeForRoles || "").replace((/(\s+|\||,|;)/igm), ";").split(";"), userRoles, "includesAny")) { ans.delete = true }

    /* eslint-enable max-len */
    return ans;
  },

  desktopChangeLayout: (layouts) => new Promise((resolve) => {
    if (!layouts || !layouts.lg || !rz.isArray(layouts.lg)) { return resolve(fnc.memorizedValues.desktopApps) }
    fetch("/ui/changelayout", {method: "POST", credentials: "include", mode: "same-origin", body: JSON.stringify({layouts}), headers: {"Content-Type": "application/json;charset=utf-8", Accept: "application/json"}})
      .then((res) => (res.json())).then((ans) => {
        if (!ans || !ans.result || !ans.desktopApps || !rz.isArray(ans.desktopApps)) { console.log(ans?.err || "desktopChangeLayout() -> Unknown error"); return resolve(fnc.memorizedValues.desktopApps) }
        fnc.memorizedValues.desktopApps = ans.desktopApps; resolve(ans.desktopApps);
      }).catch((err) => { console.log(err); resolve(fnc.memorizedValues.desktopApps) });
  })
};

export default fnc;
